export const sectionMenu = () => ({
	type: 'SECTION_MENU'
});

export const sectionBefore = () => ({
	type: 'SECTION_BEFORE'
});

export const sectionLc = () => ({
	type: 'SECTION_LC'
});

export const sectionUc = () => ({
	type: 'SECTION_UC'
});

export const sectionNum = () => ({
	type: 'SECTION_NUM'
});

export const sectionWords = () => ({
	type: 'SECTION_WORDS'
});

export const sectionOwn = () => ({
	type: 'SECTION_OWN'
});


// WEBPACK FOOTER //
// ./src/actions/section.js